import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { LoginScreen } from './auth/Login';
import { ChangePasswordModal } from './auth/ChangePasswordModal';
import { Configurator } from './Configurator';
import { OnboardingOverlay } from './components/common/OnboardingOverlay';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Main />
      </AuthProvider>
    </QueryClientProvider>
  );
}

function Main() {
  const { user, isAuthenticated, markOnboardingComplete } = useAuth();
  const forceOnboarding = process.env.REACT_APP_FORCE_ONBOARDING === 'true';

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  const showOnboarding =
    user &&
    !user.mustChangePassword &&
    (forceOnboarding || user.onboardingCompleted === false);

  const handleFinish = async () => {
    try {
      const result = await markOnboardingComplete();
      if (!result?.success) {
        console.error('Failed to persist onboarding completion', result?.message);
      }
    } catch (error) {
      console.error('Failed to persist onboarding completion', error);
    }
  };

  return (
    <>
      <Configurator />
      {user.mustChangePassword && <ChangePasswordModal />}
      {showOnboarding && (
        <OnboardingOverlay onSkip={handleFinish} onComplete={handleFinish} />
      )}
    </>
  );
}

export default App;
